export default __webpack_public_path__ + "static/media/Icon_Arrow_up.f8c5962a.svg";